/**=========================================================
 * Module: fileicon.js
 * FileIcon Controller
 =========================================================*/

 App.controller('FileIconController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog) {
   "use strict";
   
   $scope.ext = $scope.extension
   if(!$scope.extension) $scope.ext = '---';
   if($scope.extension && $scope.extension.length>7) $scope.ext = $scope.extension.substr(0, 7);

   if($scope.selectorOptions && $scope.selectorOptions.extensions){
      if((','+$scope.selectorOptions.extensions+',').indexOf(','+$scope.extension+',') < 0){
        $scope.selectorOptions.file.unselectable = true;
      }
   }

   function getRGB(i){
     var s = ($scope.extension + 'aaa').toLowerCase();
     var c = s.charCodeAt(i) - 97;
     return ((c < 0 ? 0 : c) * 4) + 30;
   }

   $scope.style = {
     backgroundColor: 'rgb('+ getRGB(0) +','+ getRGB(1) +','+ getRGB(2) +')'
   }
   $scope.classes = {}
   if($scope.mode=='tag'){
    $scope.classes.filetag = true
   }
   if($scope.extension=='weblink'){
    $scope.ext = ''
    $scope.style = { backgroundColor: 'transparent', color: '#666'}
    $scope.classes = { 'fa': true, 'aqi-link': true }
   }
     
 }
 ]);